const mediaQueryBreakpoint = "48em";
const menuTransition = "transition: all 0.2s ease-out";
const menuWidth = "150px";

export { mediaQueryBreakpoint, menuTransition, menuWidth };
